<template>
  <Tag
    :data-disable="disabled || null"
    :bs="{
      mr: 8,
      my: 4,
      ...tagPropsDict.bs
    }"
    :text-bs="tagPropsDict.textBs"
    :icon="(disabled || readonly) ? '' : 'cancel-m'"
    v-bind="tagPropsDict.rest"
  >
    <slot />
  </Tag>
</template>

<script>
  import Tag from './Tag.vue'

  /**
   * 基于 Tag 封装出来，预设的输入框内部的小型样式
   */
  export default {
    name: 'InputTag',
    components: {
      Tag,
    },
    props: {
      /**
       * @ignore
       * 容器样式，BeerTag的bs会合并此样式
       */
      bs: {
        type: Object,
        default: () => ({}),
      },
      /**
       * 是否禁止
       */
      disabled: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否为只读模式
       */
      readonly: {
        type: Boolean,
        default: false,
      },
      /**
       * 直接透传 attrs
       *
       * @deprecated 4.1.0
       */
      tagProps: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      tagPropsDict() {
        const { bs = {}, textBs = {}, ...rest } = this.tagProps
        return {
          bs: {
            bg: this.readonly ? 'unset' : undefined,
            '&:hover:not([data-disable="true"])': {
              bg: this.readonly ? 'unset' : undefined,
            },
            ...bs,
            ...this.bs,
          },
          textBs: {
            maxWidth: 188,
            mr: 4,
            ...textBs,
          },
          rest: {
            ...rest,
            ...this.$attrs,
          },
        }
      },
    },
  }
</script>
